import React, { useState, useEffect } from "react";
import { normalizeConflictFieldEntry } from "../lib/conflictUtils";

function ConflictModal({ conflicts = [], onResolve, session }) {
  const [index, setIndex] = useState(0);
  const current = conflicts[index] || null;

  useEffect(() => {
    if (index > 0 && index >= conflicts.length) setIndex(Math.max(0, conflicts.length - 1));
  }, [conflicts.length, index]);

  if (!current) return null;

  const items = Array.isArray(current.conflict_items) ? current.conflict_items : [];
  const title = current.farmName || current.farm_name || 'Registro com conflito';
  const subtitle = [current.collection, current.local_version != null ? `local v${current.local_version}` : null, current.server_version != null ? `servidor v${current.server_version}` : null].filter(Boolean).join(' • ');

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(3, 8, 20, 0.72)', zIndex: 3000,
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16
    }}>
      <div style={{
        width: 'min(820px, 100%)', maxHeight: '90vh', overflow: 'auto',
        background: '#08152d', border: '1px solid rgba(255,255,255,0.12)', borderRadius: 18,
        boxShadow: '0 24px 80px rgba(0,0,0,0.45)', color: '#eaf2ff'
      }}>
        <div style={{ padding: '18px 18px 12px', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
          <div style={{ fontSize: 18, fontWeight: 800 }}>Conflito de sincronização</div>
          <div style={{ opacity: 0.8, marginTop: 6 }}>{title}</div>
          {subtitle ? <div style={{ opacity: 0.6, fontSize: 13, marginTop: 4 }}>{subtitle}</div> : null}
          {conflicts.length > 1 ? (
            <div style={{ opacity: 0.6, fontSize: 12, marginTop: 8 }}>
              {index + 1} de {conflicts.length} conflitos pendentes
            </div>
          ) : null}
        </div>

        <div style={{ padding: 18 }}>
          {items.length ? (
            <div style={{ display: 'grid', gap: 12 }}>
              {items.map((item, idx) => {
                const fields = (Array.isArray(item.fields) ? item.fields : [])
                  .map((field) => normalizeConflictFieldEntry(field, item))
                  .filter((field) => field && field.field);
                return (
                  <div key={idx} style={{ border: '1px solid rgba(255,255,255,0.08)', borderRadius: 14, padding: 14, background: 'rgba(255,255,255,0.03)' }}>
                    <div style={{ display:'flex', justifyContent:'space-between', gap:12, alignItems:'center', marginBottom: 10, flexWrap:'wrap' }}>
                      <div style={{ fontWeight: 700 }}>Registro {item.id || `#${idx + 1}`}</div>
                      <div style={{ fontSize: 12, opacity: 0.72 }}>
                        {Array.isArray(item.manualFields) && item.manualFields.length > 0 ? `${item.manualFields.length} campo(s) exigem revisão` : 'Conflito detectado'}
                      </div>
                    </div>
                    {fields.length ? (
                      <div style={{ display:'grid', gap:10 }}>
                        {fields.map((field) => (
                          <div key={field.field} style={{ border:'1px solid rgba(255,255,255,0.08)', borderRadius:12, overflow:'hidden' }}>
                            <div style={{ padding:'8px 12px', background:'rgba(255,255,255,0.04)', display:'flex', justifyContent:'space-between', gap:8, flexWrap:'wrap' }}>
                              <div style={{ fontWeight:700 }}>{field.field}</div>
                              <div style={{ fontSize:11, opacity:0.72 }}>{field.manualRequired ? 'Revisão recomendada' : `Escolha automática: ${field.chosen}`}</div>
                            </div>
                            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:1, background:'rgba(255,255,255,0.06)' }}>
                              <div style={{ padding:10, background:'#08152d' }}>
                                <div style={{ fontSize:11, textTransform:'uppercase', opacity:0.65, marginBottom:6 }}>Base</div>
                                <pre style={{ margin:0, whiteSpace:'pre-wrap', wordBreak:'break-word', fontSize:12, lineHeight:1.45, color:'#d7e5ff' }}>{JSON.stringify(field.base, null, 2)}</pre>
                              </div>
                              <div style={{ padding:10, background:'#08152d' }}>
                                <div style={{ fontSize:11, textTransform:'uppercase', opacity:0.65, marginBottom:6 }}>Local</div>
                                <pre style={{ margin:0, whiteSpace:'pre-wrap', wordBreak:'break-word', fontSize:12, lineHeight:1.45, color:'#d7e5ff' }}>{JSON.stringify(field.local, null, 2)}</pre>
                              </div>
                              <div style={{ padding:10, background:'#08152d' }}>
                                <div style={{ fontSize:11, textTransform:'uppercase', opacity:0.65, marginBottom:6 }}>Servidor</div>
                                <pre style={{ margin:0, whiteSpace:'pre-wrap', wordBreak:'break-word', fontSize:12, lineHeight:1.45, color:'#d7e5ff' }}>{JSON.stringify(field.server, null, 2)}</pre>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div style={{ opacity: 0.8, lineHeight: 1.5 }}>Encontramos um conflito entre os dados locais e os dados do servidor.</div>
                    )}
                  </div>
                );
              })}
            </div>
          ) : (
            <div style={{ opacity: 0.8, lineHeight: 1.5 }}>
              Encontramos um conflito entre os dados locais e os dados do servidor. Escolha qual versão deve ser mantida.
            </div>
          )}
        </div>

        <div style={{
          display: 'flex', justifyContent: 'space-between', gap: 12, padding: 18,
          borderTop: '1px solid rgba(255,255,255,0.08)', flexWrap: 'wrap'
        }}>
          <div style={{ opacity: 0.65, fontSize: 12 }}>
            Usuário: {session?.user?.name || session?.name || session?.email || 'Sessão atual'}
          </div>
          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
            <button className="btn secondary" onClick={() => onResolve?.(current, 'server')}>Manter servidor</button>
            <button className="btn secondary" onClick={() => onResolve?.(current, 'merged')}>Mesclar automático</button>
            <button className="btn" onClick={() => onResolve?.(current, 'local')}>Manter local</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ConflictModal;
export { ConflictModal };
